import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translations: require('./locales/eng.json'),
        },
        geo: {
            translations: require('./locales/geo.json'),
        },
    },
    lng: 'geo',
    fallbackLng: 'en',
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ',',
    },
    react: { useSuspense: true }
});

export default i18n;
